import React from 'react';
import HighlightFeature, {
  ACTION_SAVE_QUERY,
  BOTTOM_LEFT,
} from '@/components/HighlightFeature';
import { ONBOARDING_SAVE_QUERY_REQUIRED_ACTION } from '@/views/QueryBuilder/subcomponents';

export const SaveQuerySuggestion = () => (
  <HighlightFeature
    requiredActions={ONBOARDING_SAVE_QUERY_REQUIRED_ACTION}
    position={BOTTOM_LEFT}
    text={
      <span>
        <b>Save your query</b>, or save changes to an existing saved query.
      </span>
    }
    targetAction={ACTION_SAVE_QUERY}
    style={{ minWidth: '250px' }}
    delay={4000}
    hideWhenModalsOpen
  />
);
